import { navigate, RouteComponentProps } from '@reach/router'
import { Button, Col, Row, Statistic, Collapse, Divider } from 'antd'
import React from 'react'
import useSWR from 'swr'
import styled from 'styled-components'
import { Ad, Card, Title } from '../components/ui'
import Small from '../assets/product-small.jpg'
import Big from '../assets/product-big.png'
import Super from '../assets/product-super.jpg'
import { api } from '../common/api'
import { AccountSummary as Summary } from '../services/account-summary'
import { ROOT_PATH } from '../common/config'

const { Panel } = Collapse

const StyledAccountSummary = styled.div`
  padding-top: 20px;

  .scroll-item {
    height: 320px;
    color: #fff;
    line-height: 160px;
    text-align: center;
    background: #364d79;
  }

  .ant-collapse-content-box {
    background-color: #fff;
    border: 2px solid rgba(229, 231, 235, var(--tw-bg-opacity));
  }

  .ant-statistic-title {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.7);
  }

  .row {
    display: flex;
    flex-direction: row;
  }

  .wrap {
    flex-wrap: wrap;
  }

  .right {
    margin-top: auto;
    display: flex;
    justify-content: flex-end;
    align-items: baseline;

    span:first-of-type {
      margin-right: 5px;
    }
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .between {
    justify-content: space-between;
  }

  .center {
    align-items: center;
  }

  .gray {
    color: #c4c4c4 !important;
  }

  .card {
    padding: 15px;
    margin-bottom: 15px;
  }

  .info {
    min-height: 196px;
    display: flex;
    align-items: center;

    .ant-row {
      width: 100%;
    }

    .ant-statistic {
      text-align: center;
    }
    .ant-statistic-content-value-int {
      font-weight: bold;
      font-size: 38px;
    }
  }

  .items {
    .card {
      height: 135px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 45px;
      min-width: 260px;
      max-width: 260px;
      border-top: 10px solid transparent;
    }
    .card:last-of-type {
      margin-right: 0;
    }

    .card:nth-of-type(1) {
      border-color: rebeccapurple;
    }

    .card:nth-of-type(2) {
      border-color: chartreuse;
    }

    .card:nth-of-type(3) {
      border-color: coral;
    }

    @media (max-width: 992px) {
      .card {
        margin: 12px auto;
      }
      .card:last-of-type {
        margin: 12px auto;
      }
    }
  }

  .make-payment {
    width: 50%;
    max-width: 483px;
    margin-left: 45px;
    background-color: #1abcfe;
    color: #fff;
    h3 {
      color: #fff !important;
      margin: 0;
    }

    p {
      opacity: 0.8;
    }

    img {
      width: 148px;
      margin: -20px 0;
    }

    button {
      width: 100%;
    }
  }
`

export const AccountSummary: React.FC<RouteComponentProps> = () => {
  const { data } = useSWR<Summary>('/customer/acc/info', api.get)
  // if (!data) return <Spin spinning={true}></Spin>
  return (
    <StyledAccountSummary>
      <div className="row">
        <Card className="info bg-gray-200">
          <Row>
            <Col lg={6} sm={0}>
              <div className="text-right flex flex-col justify-center h-full hidden lg:block">
                <h1 className="text-4xl font-bold">SHENMA</h1>
                <h2 className="text-2xl font-bold">Customer Portal</h2>
                <p className="text-xl font-medium italic">Anytime, Anywhere</p>
              </div>
            </Col>
            <Col lg={18} sm={24}>
              <Title className="sm:ml-16 mb-5 sm:mb-5 text-center sm:text-left">My Portfolio Summary</Title>
              <Row>
                {/* <Col span={8}>
                  <Statistic title="Total Payable" value={data?.totalPayable} prefix="RM" />
                </Col> */}
                <Col xs={24} md={8} className="block">
                  <Statistic title="Total Outstanding" value={data?.totalOutstanding} prefix="RM" />
                  <Divider className="block sm:hidden" />
                </Col>
                <Col xs={24} md={8} className="block">
                  <Statistic title="Total Payment" value={data?.totalPayment} prefix="RM" />
                  <Divider className="block sm:hidden" />
                </Col>
                <Col xs={24} md={8}>
                  <Statistic title="Due and Payable" value={data?.totalPayable} prefix="RM" />
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </div>
      <Row gutter={20}>
        <Col md={6} sm={24}>
          <Ad />
        </Col>
        <Col md={18} sm={24} className="pl-5 mt-5 sm:mt-0">
          <Collapse expandIconPosition="right" className="bg-white" bordered={false} ghost>
            <Panel
              className="mb-5 bg-gray-200"
              header={
                <>
                  <Title className="mb-5">My Portfolio Summary</Title>
                  <div className="ml-7">
                    <p className="text-lg">{data?.overViews.length} Loans Account</p>
                  </div>
                </>
              }
              key="1"
            >
              {!data || !data?.overViews || !data.overViews.length ? <p style={{ textAlign: 'center' }}>empty</p> : null}
              <LoanSummary data={data?.overViews || []} />
            </Panel>
          </Collapse>
          <Collapse expandIconPosition="right" className="bg-white" bordered={false} ghost>
            <Panel
              className="mb-5 bg-gray-200"
              header={
                <>
                  <Title className="mb-5">In-Process Loan</Title>
                  <div className="ml-7">
                    <p className="text-lg">You have {(data?.inProcesss || []).length} loan applications in processing.</p>
                  </div>
                </>
              }
              key="1"
            >
              {!data || !data?.inProcesss || !data.inProcesss.length ? <p style={{ textAlign: 'center' }}>No records found</p> : null}
              <InProcessSummary data={data?.inProcesss || []} />
            </Panel>
          </Collapse>
        </Col>
      </Row>
    </StyledAccountSummary>
  )
}

const StyledLoanSummary = styled.div`
  .ant-btn-link {
    padding-right: 0;
  }

  .loan-info {
    img {
      height: 150px;
      display: inline-block;
      width: 150px;
      border-radius: 8px;
      margin-right: 40px;
    }
  }

  .loan-digit {
    text-align: right;
  }

  .card {
    cursor: pointer;
  }

  @media screen and (max-width: 600px) {
    .loan-info {
      flex-wrap: wrap;
    }
    .loan-digit {
      width: 100%;
      text-align: left;
    }
  }
`

export const ProductImg: React.FC<{ type: '1' | '2' | '3'; className?: string }> = ({ type, className }) => {
  let imgSrc
  switch (type) {
    case '1':
      imgSrc = Small
      break
    case '2':
      imgSrc = Big
      break
    case '3':
    default:
      imgSrc = Super
  }
  return <img src={imgSrc} alt="product" />
}

export const LoanSummary: React.FC<{ data: Summary['overViews'] }> = ({ data }) => {
  return (
    <StyledLoanSummary>
      {data.map((item) => (
        <Card key={item.regNo} onClick={() => navigate(`${ROOT_PATH}/dashboard/account/${item.agreementNo}?regNo=${item.regNo}&brand=${item.brand}&model=${item.model}`)}>
          <div className="row between">
            <span>{item.prodDesc}</span>
            <Button type="link" href={`${ROOT_PATH}/dashboard/account/${item.agreementNo}?regNo=${item.regNo}&brand=${item.brand}&model=${item.model}`}>
              Transaction History
            </Button>
          </div>

          <div className="row between loan-info">
            <div className="hidden sm:block">
              <div className="row">
                <ProductImg type={item.prodImgCode} />
              </div>
            </div>
            <div className="sm:ml-auto sm:mr-auto h-full sm:h-auto leading-loose">
              <p>
                <b>Agreement Number:</b> {item.agreementNo}
              </p>
              <p>
                <b>Brand:</b> {item.brand}
              </p>
              <p>
                <b>Model:</b> {item.model}
              </p>
              <p>
                <b>Reg No:</b> {item.regNo}
              </p>
            </div>
            <div className="loan-digit flex flex-col leading-10">
              <span>Loan Amount</span>
              <span>
                <span style={{ fontWeight: 'bold', fontSize: 24 }}>{item.loanAmt || 0} </span>
                <span className="gray">RM</span>
              </span>
              <span>Last Payment Date: {item.lstPytDate || '--'}</span>
            </div>
          </div>
        </Card>
      ))}
    </StyledLoanSummary>
  )
}

export const InProcessSummary: React.FC<{ data: Summary['inProcesss'] }> = ({ data }) => {
  return (
    <StyledLoanSummary>
      {data.map((item) => (
        <Card key={item.applNo}>
          <div className="row between loan-info">
            <div className="row">
              <ProductImg type={item.prodImgCode} />
              <div>
                <p>
                  <b>Application Date:</b> {item.applDate}
                </p>
                <p>
                  <b>Dealer:</b> {item.dealer}
                </p>
                <p>
                  <b>Application Number:</b> {item.applNo}
                </p>
                <p>
                  <b>Brand:</b> {item.brand}
                </p>
                <p>
                  <b>Model:</b> {item.model}
                </p>
                {/* <p>
                  <b>Status:</b> {item.status}
                </p> */}
              </div>
            </div>
            <div className="loan-digit column between">
              <span>Cash Price</span>
              <span>
                <span style={{ fontWeight: 'bold', fontSize: 24 }}>RM {item.cash || 0} </span>
              </span>
              <span>Deposit</span>
              <span>
                <span style={{ fontWeight: 'bold', fontSize: 24 }}>RM {item.deposit || 0} </span>
              </span>
              <span>Loan Amount</span>
              <span>
                <span style={{ fontWeight: 'bold', fontSize: 24 }}>RM {item.amount || 0} </span>
              </span>
            </div>
          </div>
        </Card>
      ))}
    </StyledLoanSummary>
  )
}
